<template>
  <div :class="$style.container">
    <CircledCharacter>1</CircledCharacter>
    <div :class="$style.sectionContent">
      <HeadingSmall>
        Subscription Details
      </HeadingSmall>
      <SubscriptionTypeEdit
        v-if="isEditMode"
        :hasReachedSection="hasReachedSection"
        @cancelled="handleCancel"
        @continue="handleContinue"
      />
      <SubscriptionTypeReview
        v-else
      />
    </div>
    <div v-if="!isEditMode && hasReachedSection">
      <IconButton
        data-test-id="SubscriptionTypeSection__editButton"
        hasNoBackground
        hasOutline
        icon="edit"
        text="edit"
        type="informational"
        @click="handleEdit"
      />
    </div>
  </div>
</template>

<script>
import {
  HeadingSmall,
  IconButton,
} from '@jumpcloud/ui-components';
import { eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapGetters } from 'vuex';
import { paymentFormSections } from 'client/Payments/constants/PaymentConstants';
import { paymentModuleName } from '@jumpcloud/ui-payments';
import CircledCharacter from 'client/Payments/newComponents/CircledCharacter.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import SubscriptionTypeEdit from 'client/Payments/newComponents/SubscriptionTypeEdit.vue';
import SubscriptionTypeReview from 'client/Payments/newComponents/SubscriptionTypeReview.vue';

const {
  description,
  location,
  section,
  text: textEventProp,
} = eventProperties;
const {
  subscriptionTypeSection,
} = paymentFormSections;

const pricingModule = 'PricingModule';

export default {
  name: 'SubscriptionTypeSection',

  EventHelper,

  components: {
    CircledCharacter,
    HeadingSmall,
    IconButton,
    SubscriptionTypeEdit,
    SubscriptionTypeReview,
  },

  props: {
    hasReachedSection: Boolean,
    isCancelable: {
      type: Boolean,
      default: true,
    },
    isEditMode: Boolean,
    location: {
      type: String,
      required: true,
    },
    section: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters(paymentModuleName, { hasCreditCard: 'areRequiredPaymentFieldsSet' }),
    ...mapGetters(pricingModule, { isAnnual: 'getIsAnnual' }),
  },

  methods: {
    handleCancel() {
      this.$emit('cancelled');
    },

    handleContinue() {
      const billingType = this.isAnnual ? 'Annual Billing' : 'Monthly Billing';
      const creditCardStatus = `${this.hasCreditCard ? 'has' : 'does not have'} credit card`;
      this.$options.EventHelper.triggerButtonClicked({
        [description]: `Continue clicked on Subscription Type Section: ${billingType}: ${creditCardStatus}`,
        [location]: this.location,
        [section]: this.section,
        [textEventProp]: 'Continue',
      });
      this.$emit('clickedContinue', subscriptionTypeSection);
    },

    handleEdit() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'Edit clicked on Subscription Type Section',
        [location]: this.location,
        [section]: this.section,
        [textEventProp]: 'Edit',
      });

      this.$emit('clickedEdit', subscriptionTypeSection);
    },
  },
};
</script>

<style module scoped>
.container {
  display: flex;
  gap: var(--jc-spacer);
  margin-top: var(--jc-spacer);
}

.sectionContent {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
</style>
